'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Switch = function (_React$Component) {
    (0, _inherits3.default)(Switch, _React$Component);

    function Switch(props) {
        (0, _classCallCheck3.default)(this, Switch);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Switch.__proto__ || (0, _getPrototypeOf2.default)(Switch)).call(this, props));

        _this.onChange = function (e) {
            var onChange = _this.props.onChange;

            var _ref = e && e.currentTarget,
                checked = _ref.checked;

            /* istanbul ignore else */


            if (typeof checked === 'boolean') {
                _this.setState({ checked: checked });
                if (onChange) {
                    onChange(checked, e);
                }
            }
        };

        _this.state = {
            checked: _this.props.checked
        };

        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Switch, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var checked = nextProps.checked;
            /* istanbul ignore else */

            if (this.props.checked !== checked) {
                this.setState({ checked: checked });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                dataTn = _props.dataTn,
                label = _props.label,
                name = _props.name,
                onText = _props.onText,
                offText = _props.offText,
                theme = _props.theme,
                value = _props.value;
            var checked = this.state.checked;


            if (!theme) {
                return null;
            }

            var switchClasses = (0, _classnames2.default)(theme.switch, (0, _defineProperty3.default)({}, theme.isChecked, checked));

            var sliderClasses = (0, _classnames2.default)(theme.slider, (0, _defineProperty3.default)({}, theme.isActive, checked));

            return _react2.default.createElement(
                'div',
                { className: theme.wrapper },
                label && _react2.default.createElement(
                    'div',
                    { className: theme.label },
                    label
                ),
                _react2.default.createElement(
                    'label',
                    { htmlFor: name, className: switchClasses, 'data-tn': dataTn },
                    _react2.default.createElement('input', {
                        id: name,
                        name: name,
                        type: 'checkbox',
                        className: theme.hiddenInput,
                        checked: checked,
                        onChange: this.onChange,
                        value: value
                    }),
                    _react2.default.createElement('div', { className: theme.dot }),
                    _react2.default.createElement(
                        'div',
                        { className: sliderClasses },
                        _react2.default.createElement(
                            'div',
                            { className: theme.sliderTextOn },
                            onText
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: theme.sliderTextOff },
                            offText
                        )
                    )
                ),
                children
            );
        }
    }]);
    return Switch;
}(_react2.default.Component);

Switch.defaultProps = {
    onText: 'I',
    offText: 'O'
};


Switch.displayName = 'Switch';

exports.default = Switch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/Switch/index.js
// module id = ./node_modules/dibs-elements/lib/Switch/index.js
// module chunks = 4